var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWalletDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_4021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5524 4.86833H14.5524C14.7292 4.86833 14.8988 4.93857 15.0238 5.06359C15.1488 5.18861 15.2191 5.35818 15.2191 5.53499V13.535C15.2191 13.7118 15.1488 13.8814 15.0238 14.0064C14.8988 14.1314 14.7292 14.2017 14.5524 14.2017H2.55241C2.3756 14.2017 2.20603 14.1314 2.081 14.0064C1.95598 13.8814 1.88574 13.7118 1.88574 13.535V2.86833C1.88574 2.69152 1.95598 2.52195 2.081 2.39692C2.20603 2.2719 2.3756 2.20166 2.55241 2.20166H12.5524V4.86833ZM3.21908 6.20166V12.8683H13.8857V6.20166H3.21908ZM3.21908 3.53499V4.86833H11.2191V3.53499H3.21908ZM10.5524 8.86833H12.5524V10.2017H10.5524V8.86833Z",
    fill: "#9DA3B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_4021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.552246 0.20166)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletDrop);
export default __webpack_public_path__ + "static/media/icon-wallet-drop.694a91e3e2a1e4030e9904550e369e73.svg";
export { ForwardRef as ReactComponent };